<template>
    <div class="c-home-template">
        <ElementsHero>
            <template v-slot:hero-media>
                <UiImage v-if="!!data?.heroImage.length && !data?.heroVideo.length" :src="data?.heroImage[0].webp" />
                <UiVideo v-else :poster-url="data?.heroImage[0].webp" :video-url="data?.heroVideo[0].url" />
            </template>
            <template v-slot:hero-center>
                <div class="intro centered">
                    <div v-if="!!data.heroLogo.length" class="intro-logo">
                        <NuxtImg :src="data.heroLogo[0].url" :alt="data.heroLogo[0].title" class="responsive" />
                    </div>
                    <h2 class="intro-text bottom" v-html="nl2br(data.heroHeadline)"></h2>
                    <div v-if="data.heroDescription" class="intro-description">
                        <h6 v-html="nl2br(data.heroDescription)"></h6>
                    </div>
                </div>

                <UiScrollDown v-show="isMobile" />
            </template>
            <template v-slot:hero-left>
                <WidgetTalkToExpert v-if="data.heroWidgetDealer" />
            </template>
            <template v-slot:hero-right>
                <WidgetProduct v-if="data.heroWidgetNewProduct" />
            </template>
        </ElementsHero>
        <ElementsIntro :data="intro" />
        <ElementsProductsPromotion :data="promotions" :background="'bg-grey'" />
        <ElementsBoxes :data="boxes" />
        <ElementsComparison :data="compare" />
        <ElementsReviews :data="reviews" :background="'bg-grey'" />
        <ElementsPosts v-if="!!community.articles.length" :data="community" />
        <ElementsInstagram />
    </div>
</template>

<script setup>
    const props = defineProps({
        data: {
            type: Object,
            default: {}
        }
    });

    const isMobile = useMediaQuery("(max-width: 768px)");

    const intro = computed(() => ({
        logo: props.data.introLogo,
        label: props.data.introLabel,
        text: props.data.introText,
        description: props.data.introDescription,
        images: props.data.introGallery
    }));

    const promotions = computed(() => ({
        title: props.data.promotionHeadline,
        links: props.data.promotionLink,
        promotions: props.data.promotions
    }));

    const boxes = computed(() => ({
        title: props.data.boxesHeadline,
        boxes: props.data.boxes
    }));

    const compare = computed(() => ({
        lHeading: props.data.compareLeftHeading,
        rHeading: props.data.compareRightHeading,
        lDesc: props.data.compareLeftDescription,
        rDesc: props.data.compareRightDescription,
        lMedia: props.data.compareLeftMedia,
        rMedia: props.data.compareRightMedia,
        lVideo: props.data.compareLeftVideo,
        rVideo: props.data.compareRightVideo
    }));

    const reviews = computed(() => ({
        title: props.data.reviewsHeadline,
        reviews: props.data.reviews
    }));

    const community = computed(() => ({
        title: props.data.communityHeadline,
        link: props.data.communityLink,
        articles: props.data.articles
    }));
</script>
